module.exports = __webpack_public_path__ + "static/device_phone_apple_light-8ddd4186e08e3f06f9f7a27034345c7a.png";